module.exports = {
    APP_VERSION: '0.6.19',
};
